// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__ePVOM","img":"Carousel_img__cOZem"};